/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-02-15 16:25:20
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-02-15 17:19:15
 * @FilePath: \Quickerz_user_manager_240215_add_user_rent_company\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueResource from 'vue-resource'
Vue.use(VueResource);

import VueQrcodeReader from "vue-qrcode-reader";
Vue.use(VueQrcodeReader);

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import VuePapaParse from 'vue-papa-parse'
Vue.use(VuePapaParse)

import './assets/icons/iconfont/iconfont.css';


import * as VueGoogleMaps from "vue2-google-maps";
 
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCBTc7od7cJwB4mN_DoM5y4Dx4inPUUPxw",
    libraries: "places" // necessary for places input
  }
});

import { PullRefresh , List } from 'vant'

export default {
        components: {
                 PullRefresh,
                 List
    }
}
Vue.use(PullRefresh);



import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import moment from 'moment'
Vue.prototype.$moment = moment;


// import axios from 'axios'
// Vue.use(axios)

Vue.config.productionTip = false

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
